import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'

export const RichTextEditorContainer = styled.div`
  width: 100%;
  & .react-mde {
    width: 100%;
    border-radius: 20px;
    & > .mde-header {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 90px;
      padding: 8px;
      border-radius: 20px 20px 0 0;
    }
    & > div:nth-child(2) {
      & .mde-textarea-wrapper {
        & textarea {
          border-radius: 0 0 20px 20px;
        }
      }
    }
  }
`

export const RichTextboxLabel = styled.label`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: ${palette.neutral[900]};
`
